import { useEffect } from "react";

export const SITE_TITLE = "jmartgraphix";

/** Set browser tab title: "Page · jmartgraphix" or just site name. */
export function setPageTitle(page?: string | null) {
  const part = page?.trim();
  document.title = part ? `${part} · ${SITE_TITLE}` : SITE_TITLE;
}

/** React hook — updates document.title whenever `page` changes. */
export function usePageTitle(page?: string | null) {
  useEffect(() => {
    setPageTitle(page);
  }, [page]);
}
